import React, { Component } from 'react';

import classes from './Notification.css';
import closeSuccessImg from '../../../../assets/images/close-success-icon.png';
import closeDangerImg from '../../../../assets/images/close-danger-icon.png';
import closeNeutralImg from '../../../../assets/images/close-neutral-icon.png';
import Icon from '../../Icon/Icon';

class Notification extends Component {

  state = {
    extraClass: null
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !this.state.extraClass && nextState.extraClass;
  }

  componentWillUnmount() {
    if (this.props.notificationType === 'Success') {
      clearTimeout(this.timer);
      clearTimeout(this.fadeOut);
    }
  }

  componentDidMount() {
    if (this.props.notificationType === 'Success') {
      this.timer = setTimeout(() => {
        if (this.props.notificationType === 'Success') {
          this.props.closeNotification();
        }
      }, 3500);
      this.fadeOut = setTimeout(() => {
        if (this.props.notificationType === 'Success') {
          this.setState({ extraClass: 'FadeOut' });
        }
      }, 3250);
    } else {
      this.setState({ extraClass: null });
    }
  }

  closeButton() {
    this.setState({ extraClass: 'FadeOut' });
    this.exit = setTimeout(this.props.closeNotification, 250);
  }

  render() {
    let notificationClasses = [classes.Notification, classes[this.props.notificationType]];
    if (!this.props.children) {
      notificationClasses.push(classes.Empty);
    }
    if (this.state.extraClass) {
      notificationClasses.push(classes[this.state.extraClass])
    }

    let closeImg = closeNeutralImg;
    if (this.props.notificationType === 'Success') {
      closeImg = closeSuccessImg;
    } else if (this.props.notificationType === 'Danger') {
      closeImg = closeDangerImg;
    }

    return (
      <div
        className={notificationClasses.join(' ')}>
        <div className={classes.CloseButtonHolder}>
          <button className={classes.CloseButton} onClick={(ev) => this.closeButton()}>
            <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
          </button>
        </div>
        <p className={classes.NotificationMessage}>
          {this.props.children}
        </p>
      </div>
    );
  }
};

export default Notification;



// WEBPACK FOOTER //
// ./src/components/UI/NotificationHolder/Notification/Notification.js